import type { paths } from "@/api-schema";
import { Action } from "@/api-schema-enums";
import { useCasaviContactWhitelistByUuidQuery } from "@/common/api/casavi/contact-whitelist/use-casavi-contact-whitelist-by-uuid.query";
import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { UuidExistenceWrapper } from "@/components/uuid-existence-wrapper/uuid-existence-wrapper";
import { useTranslation } from "react-i18next";
import { useParams } from "wouter";
import { ContactWhitelistForm } from "../_components/contact-whitelist-form";

interface UpdateViewParams {
  uuid: string;
}

export function UpdateView() {
  const { t } = useTranslation(["casavi"]);
  const params = useParams<UpdateViewParams>();
  const uuid = params.uuid;

  return (
    <UuidExistenceWrapper<
      paths["/v1/casavi-contact-whitelist/{uuid}"]["get"]["parameters"]["query"],
      paths["/v1/casavi-contact-whitelist/{uuid}"]["get"]["responses"][200]["content"]["application/json"]
    >
      uuid={uuid}
      query={useCasaviContactWhitelistByUuidQuery}
      notFoundProps={{
        title: t("casavi:ContactWhitelistEntryNotFound"),
        message: t("casavi:ContactWhitelistEntryDoesNotExist"),
        description: t("casavi:ContactWhitelistCheckIdOrContactSupport"),
        backTo: "~/cas/contact-whitelist",
        backToLabel: t("casavi:BackToContactWhitelist"),
      }}
    >
      <UpdateViewContent uuid={uuid} />
    </UuidExistenceWrapper>
  );
}

function UpdateViewContent({ uuid }: { uuid: string }) {
  const { t } = useTranslation(["casavi", "common"]);
  const pageTitle = t("casavi:EditContactWhitelistEntry");
  const pageSubtitle = t("casavi:EditCasaviContactWhitelistEntry");
  const { data: contactWhitelist } = useCasaviContactWhitelistByUuidQuery(uuid);

  if (!contactWhitelist) {
    return null;
  }

  return (
    <CenteredLayout variant={CenteredLayoutVariant.Form} title={pageTitle} subTitle={pageSubtitle}>
      <ContactWhitelistForm
        key={`${contactWhitelist.uuid}-${contactWhitelist.updatedAt}`}
        mode={Action.Update}
        uuid={uuid}
        initialData={contactWhitelist}
      />
    </CenteredLayout>
  );
}
